import React, { Component, useState, useEffect } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  InputGroup,
  Form,
  InputGroupAddon,
  Alert,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

// import the redux
import { useSelector, useDispatch } from "react-redux";

import {
  BsFillPencilFill,
  BsFillXCircleFill,
  BsFillCheckCircleFill,
  BsFillPersonFill,
  BsEnvelopeFill,
  BsFillCheckSquareFill,
  BsFillArrowDownCircleFill,
} from "react-icons/bs";
import { changeStatus, getProfile, updateDataJson } from "../../store/actions";

// import the components bootstrap
import { Button as B, Modal as M } from "react-bootstrap";

import useHttp from "../../hook/use-http";
import { toast } from "react-toastify";

import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

//Import Breadcrumb
//import Breadcrumbs from '../../components/Common/Breadcrumb';

/* This array represent different provider */
const providers = [
  { id: 1, name: "SIGLO 21" },
  { id: 2, name: "TECNOMEGA" },
  { id: 3, name: "MEGAMICRO" },
];

/* This array represent the list of type of channel */

const typesBanner = [
  { id: 1, name: "TRADICIONAL" },
  { id: 2, name: "CONNECT" },
];

const BannerDetails = ({ match, history }) => {
  // this variable will be used to control the result of the form
  const [messageRequest, setMessageRequest] = useState("");
  // this variable will control the status of the message response
  const [messageStatusIsError, setMessageStatusIsError] = useState(null);

  // get the data with redux dispatch
  const dispatch = useDispatch();
  const dataJson = useSelector((state) => state.DataJsonConsume.data);

  // this variable will be used to set the channel selected
  const [channel, setBanner] = useState({});

  // this variable will control the if the admin can change the channel or no
  const [disabled, setDisabled] = useState(true);

  // this will be used to control de component modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // this function will be used to request the server to login the user
  const { loading, error, request } = useHttp();

  /***************************************************************/
  /***************************************************************/
  /*******  declare state variables to create a new channel ******/
  /***************************************************************/
  /***************************************************************/

  // this represent the id of the channel
  const [id, setId] = useState("");

  const [form, setForm] = useState({
    title: null,
    description: null,
    type: "Principal",
    preview: null,
    file: null,
    path: null,
    status: null,
  });

  // this will be used to save the channel before update
  const [channelBeforeUpdate, setBannerBeforeUpdate] = useState({});

  // this function will process the data result of method getProfileBanner
  // this function will be process the result of the method getListBanner
  const handleGetProfileBannerDataResponse = (response) => {
    if (response.status === 401) {
      // show a error message here
    } else {
      try {
        setId(response.id);
        setForm({
          ...response,
          preview: `${process.env.REACT_APP_S3_URL}${response.path}`,
        });

        setBannerBeforeUpdate({
            ...response,
            preview: `${process.env.REACT_APP_S3_URL}${response.path}`,
          });

        //setTipoCanal(response.tipo_canal)
        //setAcuerdoComercialDocumento(response.acuerdo_comercial)

        //seRucDocumento(selected.ruc_documento)
      } catch (error) {
        console.log(error);
      }
    }
  };

  // this function will be used to get profile of channel by ruc
  const getProfileBanner = () => {
    try {
      try {
        // set the header of the request
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
          "Authorization",
          "Bearer " + localStorage.getItem("token")
        );

        const { id } = match.params;

        request(
          {
            url: `/noauth/banner/info/${id}`,
            method: "GET",
            headers: myHeaders,
          },
          handleGetProfileBannerDataResponse
        );
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // i have different question here
    getProfileBanner();
    // these function will be used to get all documents of the channel
    //getDocuments();
  }, []);

  const convertToBase64 = (file, f) => {
    try {
      let reader = new FileReader();
      reader.readAsDataURL(file[0]);

      let base64 = reader?.result;

      try {
        reader.onload = () => {
          base64 = reader?.result;
          setForm({ ...form, preview: base64, file: file[0] });
          return file;
        };
      } catch (error) {
        return file;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const cancelBeforeUpdate = () => {
    setForm({ ...channelBeforeUpdate });

    setDisabled(true);
  };

  const updateBannerDataResponse = (response) => {
    if (response.status && response.errorCode) {
      toast(response.message, { type: "error", autoClose: 10000 });
      setMessageRequest(response.message);
      setMessageStatusIsError(true);
    } else {
      history.push("/banner-edited");
    }
  };

  const handleSubmit = () => {
    try {
      const myHeaders = new Headers();

      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      );
      let formData = new FormData();
      for (var key in form) {
        if (form.hasOwnProperty(key)) {
          // Si es un objeto de archivo, lo agregamos como un archivo al FormData
          if (key === "file" && form[key] instanceof File) {
            formData.append(key, form[key], form[key].name);
          } else if (key !== "preview") {
            // Agregar otras propiedades normales al FormData
            formData.append(key, form[key]);
          }
        }
      }

      request(
        {
          url: `/auth/banner/${id}`,
          method: "PUT",
          headers: myHeaders,
          body: formData,
        },
        updateBannerDataResponse
      );
    } catch (error) {
      console.log(error);
    }
  };

  const changeStatusBannerDataResponse = (res) => {
    getProfileBanner();
    return;
  };

  const onHandleStatusChange = () => {
    const myHeaders = new Headers();

    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    let formData = new FormData();
    for (var key in form) {
      if (form.hasOwnProperty(key)) {
        // Si es un objeto de archivo, lo agregamos como un archivo al FormData
        if (key === "file" && form[key] instanceof File) {
          formData.append(key, form[key], form[key].name);
        } else if (key !== "preview") {
          // Agregar otras propiedades normales al FormData
          formData.append(key, form[key]);
        }
      }
    }

    request(
      {
        url: `/auth/banner/${id}/${!form.status}`,
        method: "PUT",
        headers: myHeaders,
        body: formData,
      },
      changeStatusBannerDataResponse
    );
  };

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  {messageStatusIsError === true && (
                    <Alert color="danger">{messageRequest}</Alert>
                  )}
                  {messageStatusIsError === false && (
                    <Alert color="success">{messageRequest}</Alert>
                  )}

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={handleSubmit}
                  >
                    <h4 className="card-title">DATOS BANNER</h4>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="banner-update-title"
                          >
                            Titulo
                          </Label> <br />
                          <AvField
                            name="title"
                            type="text"
                            errorMessage="Ingrese la razón social"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="banner-update-title"
                            value={form.title}
                            disabled={disabled}
                            onChange={handleInputChange}
                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="banner-update-description"
                          >
                            Descripción
                          </Label> <br />
                          <AvField
                            name="description"
                            type="text"
                            errorMessage="Ingrese la descripción"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="banner-update-description"
                            value={form.description}
                            disabled={disabled}
                            onChange={handleInputChange}
                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="banner-update-type"
                          >
                            Tipo
                          </Label> <br />
                          <select
                            className="form-control"
                            disabled={disabled}
                            value={form.type}
                            name="type"
                            id="banner-update-type"
                            onChange={handleInputChange}
                          >
                            <option value="Principal">Principal</option>
                            <option value="Login">Login</option>
                          </select>
                        </div>
                      </Col>
                      <Col md="6" className="mb-3 ">
                        <Label
                          className="form-label"
                          htmlFor="validationCustom98"
                        >
                          Estado Banner 
                        </Label><br />
                        <div className="d-flex"> <AvField
                          name="status"
                          type="text"
                          className="form-control container-fluid"
                          id="validationCustom98"
                          value={form.status ? "Activo" : "Inactivo"}
                          disabled
                        />
                        <div>
                          <button
                            className={`btn ${
                              !form.status ? "btn-primary" : "btn-danger"
                            }`}
                            onClick={() => onHandleStatusChange()}
                            type="button"
                          >
                            {!form.status ? (
                              <AiFillCheckCircle />
                            ) : (
                              <AiFillCloseCircle />
                            )}
                          </button>
                        </div></div>
                      </Col>
                      <Col md="6" className="d-flex flex-row ">
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="banner-update-image"
                          >
                            Subir imagen
                          </Label> <br />
                          <AvField
                            name="file-banner"
                            accept="image/*"
                            type="file"
                            errorMessage="Ingrese la imagen"
                            className="form-control"
                            //validate={{ required: { value: true } }}
                            id="banner-update-image"
                            disabled={disabled}
                            onChange={(e) => {
                              const f = e.target.files[0];
                              convertToBase64(e.target.files, f);
                              //setAcuerdoComercialDocumento(e.target)
                              /*
                                                            setAcuerdoComercialDocumento(
                                                                convertToBase64AcuerdoComercial(e.target.files, f)
                                                            )
                                                            */
                            }}
                          />
                        </div>
                      </Col>

                      {form.preview && (
                        <Col md="6">
                          <div className="mb-3 w-100">
                            <Label
                              className="form-label"
                              htmlFor="banner-create-preview"
                            >
                              Previsualización
                            </Label>
                            <br />
                            <div className="w-100 text-center">
                              <img
                                src={form.preview}
                                className="img-fluid"
                                alt="banner-preview"
                              />
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>

                    {disabled ? (
                      <Button
                        className="btn btn-primary-lexmark"
                        type="button"
                        onClick={() => {
                          setDisabled(false);
                        }}
                      >
                        Editar
                      </Button>
                    ) : (
                      <>
                        <Button
                          className="btn btn-primary-danger mx-2"
                          type="button"
                          onClick={cancelBeforeUpdate}
                        >
                          Cancelar
                        </Button>

                        <Button
                          className="btn btn-primary-lexmark"
                          type="submit"
                        >
                          Guardar
                        </Button>
                      </>
                    )}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BannerDetails;
